import { useQuoteComplianceChecks } from 'components/hooks/quotes/useQuoteComplianceChecks'
import ComplianceChecks from 'components/quoting/quotes/compliance/ComplianceChecks'

import { useSelfServeExplorerContext } from './QuoteSelfServeExplorerContext'
import { useQuote } from '../QuoteProvider'

export const QuoteComplianceChecks = () => {
  const { isLoading } = useSelfServeExplorerContext()
  const {
    employeesWithUnaffordablePlans,
    ratingAreasWithUnfairAllowances,
  } = useQuoteComplianceChecks()

  const { quote } = useQuote()

  return (
    <div>
      <h2 className='body-sm text-gray-500 mb-2'>Compliance checks</h2>
      <ComplianceChecks
        maxEmployeeContributionPercentage={quote?.max_employee_contribution_percentage}
        employeesWithUnaffordablePlans={employeesWithUnaffordablePlans}
        ratingAreasWithUnfairAllowances={ratingAreasWithUnfairAllowances}
        isLoading={isLoading}
      />
    </div>
  )
}
